import Table from "react-bootstrap/Table";
import React, { Fragment } from "react";
import { ShiftTableTitle } from "./ShiftTableTitle";
import { TimesheetStatusTextIcon } from "./TimesheetStatusTextIcon";

const ShiftShiftStatusElement = ({ shift }) => {
  if (shift === null || shift === undefined) return;

  return (
    <Fragment>
      <ShiftTableTitle title={"Shift Status"} />
      <Table striped hover responsive>
        <tbody>
          <tr>
            <td className={"tdw-50"}>Status</td>
            <td className={"font-weight-bold text-capitalize"}>
              {shift?.status.replace(/_/g, " ").toLowerCase()}
            </td>
          </tr>
          <tr>
            <td>Internal Id</td>
            <td className={"font-weight-bold"}>{shift?.id}</td>
          </tr>

          {shift?.status === "COMPLETED" ? (
            <tr>
              <td>Timesheet Status</td>
              <td className={"font-weight-bold"}>
                <TimesheetStatusTextIcon status={shift?.timesheet?.status} />
              </td>
            </tr>
          ) : null}

          {shift?.status === "UNKNOWN" ? (
            <tr>
              <td>Error</td>
              <td className={"font-weight-bold"}>{shift?.shiftErrorMessage}</td>
            </tr>
          ) : null}
        </tbody>
      </Table>
    </Fragment>
  );
};

export default ShiftShiftStatusElement;
